import React from 'react';

import { Grid } from '@mui/material';
import {
  BoldText,
  InputLabel,
  Row,
  RowItem,
  StyledCheckBox,
  PlaceholderBox,
  Text,
} from './StyledComponents';
import W86PlaceholderTextField from '../../W86Components/W86PlaceholderTextField';

function PlaceholderSelection(props) {
  // Get unique placeholders by key
  const getUniquePlaceholders = () => {
    if (!props.availablePlaceholders?.length) return [];

    const uniquePlaceholders = [];
    const keys = new Set();

    props.availablePlaceholders[0].placeholders.forEach(ph => {
      if (!keys.has(ph.key)) {
        keys.add(ph.key);
        uniquePlaceholders.push(ph);
      }
    });

    return uniquePlaceholders;
  };

  const uniquePlaceholders = getUniquePlaceholders();

  const checkIfSelected = pH => {
    const isSelected = props.savedPlaceholders.some(sPH => sPH.key === pH.key);
    return isSelected;
  };

  const checkIfAllSelected = () => {
    return (
      uniquePlaceholders.length > 0 && uniquePlaceholders.length === props.savedPlaceholders.length
    );
  };

  const handleSelectAll = e => {
    if (e.target.checked) {
      // Need to select all
      const newSavedPHs = uniquePlaceholders.map(pH => {
        return {
          key: pH.key,
          value: '${' + pH.key + '}',
          type: pH.type,
          length: pH.length,
        };
      });

      props.updateState({ savedPlaceholders: newSavedPHs });
    } else {
      // Need to remove all
      props.updateState({ savedPlaceholders: [] });
    }
  };

  const handleSelectPlaceholder = (e, pH) => {
    if (e.target.checked) {
      // Check if the placeholder is already in savedPlaceholders to avoid duplicates
      if (!props.savedPlaceholders.some(sPH => sPH.key === pH.key)) {
        const newPlaceholders = [
          ...props.savedPlaceholders,
          {
            key: pH.key,
            value: '${' + pH.key + '}',
            type: pH.type,
            length: pH.length,
          },
        ];
        props.updateState({ savedPlaceholders: newPlaceholders });
      }
    } else {
      const updateSavedPlaceholders = props.savedPlaceholders.filter(sPH => sPH.key !== pH.key);
      props.updateState({ savedPlaceholders: updateSavedPlaceholders });
    }
  };

  const renderPlaceholders = () => {
    return (
      <Grid container>
        <Row container item xs={12} marginBottom={'16px !important'}>
          <RowItem item>
            <StyledCheckBox
              size="medium"
              checked={checkIfAllSelected()}
              onChange={e => handleSelectAll(e)}
            />
          </RowItem>
          <RowItem item>
            <Text>Placeholders</Text>
          </RowItem>
        </Row>

        {uniquePlaceholders.map((pH, idx) => {
          const isSelected = checkIfSelected(pH);
          return (
            <Row container item xs={12} key={pH.key}>
              <RowItem item>
                <StyledCheckBox
                  size="medium"
                  checked={isSelected}
                  onChange={e => handleSelectPlaceholder(e, pH)}
                />
              </RowItem>
              <RowItem item>
                <W86PlaceholderTextField
                  disabled={true}
                  value={pH.key}
                  customStyleProps={{
                    width: '425px',
                    '& .MuiInputBase-input.Mui-disabled': {
                      color: isSelected ? 'var(--color-text-primary)' : 'var(--color-text-disabled)',
                      WebkitTextFillColor: isSelected
                        ? 'var(--color-text-primary)'
                        : 'var(--color-text-disabled)',
                    },
                  }}
                />
              </RowItem>
            </Row>
          );
        })}
      </Grid>
    );
  };

  return (
    <>
      <Grid item xs={12} marginBottom={'20px'}>
        <InputLabel>
          Output placeholders to{' '}
          <BoldText>{props.isLoopMode ? 'loop start' : 'Target Workflow'}</BoldText>
        </InputLabel>
      </Grid>
      {renderPlaceholders()}
    </>
  );
}

export default PlaceholderSelection;
